/**
 * Convert Java LocalDateTime array to ISO string
 * Java format: [year, month, day, hour, minute, second, nanosecond]
 * @param {Array} dateTimeArray - Array representation of LocalDateTime
 * @returns {string|null} ISO date string or null
 */
export const convertLocalDateTimeToISO = (dateTimeArray) => {
  if (
    !dateTimeArray ||
    !Array.isArray(dateTimeArray) ||
    dateTimeArray.length < 6
  ) {
    return null
  }

  try {
    // dateTimeArray format: [year, month, day, hour, minute, second, nanosecond]
    const [year, month, day, hour, minute, second, nano] = dateTimeArray

    // JavaScript Date months are 0-indexed, Java months are 1-indexed
    const date = new Date(
      year,
      month - 1, // Convert Java 1-indexed month to JS 0-indexed
      day,
      hour,
      minute,
      second,
      Math.floor(nano / 1000000) // Convert nanoseconds to milliseconds
    )

    return date.toISOString()
  } catch (error) {
    console.error('Error converting LocalDateTime array to ISO:', error)
    return null
  }
}

/**
 * Format LocalDateTime array to human-readable string
 * @param {Array} dateTimeArray - Array representation of LocalDateTime
 * @returns {string|null} Formatted date string
 */
export const formatLocalDateTime = (dateTimeArray) => {
  const isoString = convertLocalDateTimeToISO(dateTimeArray)
  if (!isoString) return null

  return new Date(isoString).toLocaleString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}
